import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  CategoryFinance,
  GetCategoriesFinanceSelect,
  CreateCategoryFinance,
  UpdateCategoryFinance,
  DeleteCategoryFinance,
} from '../../../store/actions';

/**
 * CategoriesFinanceInjection is responsible for injecting the methods about store of categories finance.
 *
 * @return
 *  categoriesFinance: Array of categoriesFinance.
 *  get: () => Void
 *  create: () => void
 *  update: () => void
 *  delete: () => void
 */
export const CategoriesFinanceInjection = () => {
  /* constants */
  const dispatch = useDispatch();

  /**
   * @connectors
   *
   * these methods are responsible for accessing the store and dispatch the actions.
   * these guarantee that the module will be connected independent of methods used.
   * but you should always follow the rules of the methods.
   */

  /**
   * @return Void
   */
  const getCategoriesFinance = async () => {
    dispatch(CategoryFinance());
  };

  const getCategoriesFinanceSelect = async (type) => {
    dispatch(GetCategoriesFinanceSelect(type));
  };

  /**
   * @return Void
   */

  const createCategoriesFinance = (values, history) => {
    dispatch(CreateCategoryFinance(values, history));
  };

  const updateCategoriesFinance = (id, values, history) => {
    dispatch(UpdateCategoryFinance(id, values, history));
  };

  const deleteCategoriesFinance = (id) => {
    dispatch(DeleteCategoryFinance(id));
  };

  /**
   * @variables
   *
   *
   */
  const { categoryFinances, categoryFinanceSelect, success } = useSelector(
    (state) => ({
      categoryFinances: state.CategoryFinance.categoryFinance,
      success: state.CategoryFinance.success,
      categoryFinanceSelect: state.CategoryFinance.categoryFinanceSelect,
    })
  );

  return {
    getCategoriesFinance,
    getCategoriesFinanceSelect,
    createCategoriesFinance,
    updateCategoriesFinance,
    deleteCategoriesFinance,
    categoryFinances,
    categoryFinanceSelect,
    success,
  };
};
